import moment from "moment";
import React from "react";
import { Cell } from "react-table";
import { ModuSignDocument, ModuSignDocumentStatus } from "src/api/contract/modusign-types";
import { BaseButton } from "src/components";
import { YmdFormat } from "src/utils";

const ModuSiginDocsColumns = [
  {
    Header: "문서 이름",
    accessor: "title",
    width: 295,
  },
  {
    Header: "상태",
    accessor: "type",
    width: 320,
    Cell: ({
      row,
      openCancelModal,
      resendModuSignDocsRequest,
    }: Cell<ModuSignDocument> & {
      //
      openCancelModal: (document: ModuSignDocument) => void;
      resendModuSignDocsRequest: (documentId: string) => void;
    }) => {
      const status = ModuSignDocumentStatus[row.original.status as keyof typeof ModuSignDocumentStatus];
      let statusColor = "";
      let isDisabled = false;
      switch (status) {
        case ModuSignDocumentStatus.DRAFT:
          statusColor = "chip blue";
          isDisabled = false;
          break;
        case ModuSignDocumentStatus.SCHEDULED:
          statusColor = "chip blue";
          isDisabled = false;
          break;
        case ModuSignDocumentStatus.ON_GOING:
          statusColor = "chip green";
          isDisabled = false;
          break;
        case ModuSignDocumentStatus.ON_PROCESSING:
          statusColor = "chip green";
          isDisabled = true;
          break;
        case ModuSignDocumentStatus.PROCESSING_FAILED:
          statusColor = "chip red";
          isDisabled = true;
          break;
        case ModuSignDocumentStatus.ABORTED:
          statusColor = "chip red";
          isDisabled = true;
          break;
        case ModuSignDocumentStatus.COMPLETED:
          statusColor = "chip gray";
          isDisabled = true;
          break;
      }

      return (
        <div className="flex-center">
          <div className={statusColor}>{status}</div>
          <div className="ml10 flex-center">
            <BaseButton
              title="재전송"
              className="color-white size-small"
              disabled={isDisabled}
              onClick={() => resendModuSignDocsRequest(row.original.id)}
            />
            <BaseButton
              title="문서 취소"
              className="color-white size-small ml5"
              disabled={isDisabled}
              onClick={() => openCancelModal(row.original)}
            />
          </div>
        </div>
      );
    },
  },
  {
    Header: "수정일시",
    accessor: "updatedAt",
    width: 200,
    Cell: ({ row }: Cell<ModuSignDocument>) => {
      return <div>{moment(row.original.updatedAt).format(YmdFormat.YYYY_MM_DD_HH_MM)}</div>;
    },
  },
  {
    Header: "문서 내용 확인",
    accessor: "",
    width: 200,
    Cell: ({
      row,
      onDownloadDocument,
    }: Cell<ModuSignDocument> & { onDownloadDocument: (documentId: string, type: "file" | "auditTrail") => void }) => {
      const status = ModuSignDocumentStatus[row.original.status as keyof typeof ModuSignDocumentStatus];
      const isDisabled = status !== ModuSignDocumentStatus.COMPLETED;
      return (
        <div className="flex-center">
          <BaseButton
            title="문서"
            className="color-white size-small" //
            // disabled={isDisabled}
            onClick={() => onDownloadDocument(row.original.id, "file")}
          />
          <BaseButton
            title="감사 추적 인증서"
            className="color-white size-small ml5" //
            disabled={isDisabled}
            onClick={() => onDownloadDocument(row.original.id, "auditTrail")}
          />
        </div>
      );
    },
  },
];

export default ModuSiginDocsColumns;
